import { c as _c } from "react/compiler-runtime";
import { Typography, Stack } from '@mui/material';
import type { PropsWithChildren, ReactNode } from 'react';
export const NumericBulletSection = t0 => {
  const $ = _c(13);
  const {
    bulletNumber,
    title,
    titleAction,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      gap: "24px",
      alignItems: "start"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `${bulletNumber}.`;
  let t3;
  if ($[1] !== t2) {
    t3 = <Typography variant="h4">{t2}</Typography>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      width: "100%",
      gap: "40px"
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== title || $[5] !== titleAction) {
    t5 = titleAction ? <Stack direction="row" sx={{
      alignItems: "center",
      justifyContent: "space-between",
      gap: "16px"
    }}><Typography variant="h4">{title}</Typography>{titleAction}</Stack> : <Typography variant="h4">{title}</Typography>;
    $[4] = title;
    $[5] = titleAction;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== children || $[8] !== t5) {
    t6 = <Stack sx={t4}>{t5}{children}</Stack>;
    $[7] = children;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t6) {
    t7 = <Stack direction="row" sx={t1}>{t3}{t6}</Stack>;
    $[10] = t3;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};